<template>
  <div>
    <el-card class="mat12" v-if="!name">
      <el-row>
        <el-col :span="6" class="media_col padding-tb10 flex_class" v-if="dataDesc.startupDate">
          <h4 class="flex_shrink">初次洽谈时间：</h4>
          <span :class="{'ellipsis':$store.state.tagView}">{{dataDesc.startupDate}}</span>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" v-if="dataDesc.intentionTime">
          <h4 class="flex_shrink">意向时间：</h4>
          <span :class="{'ellipsis':$store.state.tagView}">{{dataDesc.intentionTime}}</span>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" v-if="dataDesc.createDate">
          <h4 class="flex_shrink">项目创建时间：</h4>
          <span :class="{'ellipsis':$store.state.tagView}">{{dataDesc.createDate}}</span>
        </el-col>
         <!-- <el-col :span="6" class="media_col padding-tb10 flex_class" >
          <h4 class="flex_shrink">立项撤销时间：</h4>
          <span :class="{'ellipsis':$store.state.tagView}"></span>
        </el-col> -->
      </el-row>
      <el-row v-if="dataDesc.submitFinishReason">
          <h4 class="flex_shrink">立项撤销原因：</h4>
          <span :class="{'ellipsis':$store.state.tagView}">{{dataDesc.submitFinishReason}}</span>
      </el-row>
    </el-card>

    <!-- 地图弹窗 -->
    <map-ready-dialog
      @cancel="handleCncel"
      :dialogVisible="dialogVisible"
      :center="center"
      :address="dataDesc.address"
    ></map-ready-dialog>
  </div>
</template>

<script>
export default {
  name: "CardApprovalTime",
  props: {
    dataDesc: {
      type: Object,
      default: () => {}
    },
    name: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      dialogVisible: false,
      center: {
        lng: "",
        lat: ""
      }
    };
  },
  created() {
    this.center.lng = this.dataDesc.lng;
    this.center.lat = this.dataDesc.lat;
  },

  methods: {
    // 展示地图
    handleOpenAddress() {
      this.dialogVisible = true;
      // this.center.lng = this.dataDesc.lng;
      // this.center.lat = this.dataDesc.lat;
      // this.center.lng = this.dataDesc.lng;
      // this.center.lat = this.dataDesc.lat;
    },
    // 取消关闭弹窗
    handleCncel(val) {
      this.dialogVisible = val;
    }
  }
};
</script>

<style lang="scss" scoped>
$color: #409eff;
.contrast {
  color: $color;
}
.view_history {
  cursor: pointer;
  margin-left: 10px;
}
.address_wrap {
  cursor: pointer;
  i {
    color: $color;
  }
}
</style>
